<template>
  <div>
    <div class="content_btn">
      <div class="btn_update_data">
        <button
          @click="openPopup()"
          type="button"
          class="btn btn-success"
          title="Actualiza tus datos y obtén 20 puntos"
        >
          Actualiza tus datos
        </button>
      </div>
    </div>

    <!-- Modal para escoger logueo -->
    <div
      class="modal fade"
      id="ModalRedirect"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modal_content_popup">
          <div class="content_close">
            <img
              src="../assets/icon/icon_close.png"
              width="20"
              title="cerrar popup"
              alt="cerrar popup"
              @click="closedModal()"
            />
          </div>
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalLabel"
              style="color:#6c757d; margin:auto;"
            >
              Escoge tu tipo de usuario para loguearte
            </h5>
          </div>
          <div style="margin:auto;" class="modal-footer">
            <button
              @click="IrMotero()"
              type="button"
              class="btn btn-danger btn-sm"
            >
            Soy Motero
            </button>
            <button
              @click="IrLubricador()"
              type="button"
              class="btn btn-danger btn-sm"
            >
            Soy Lubricador
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    name: "btnUpdateData",
    data(){
      return{
        
      };
    },
    methods: {
      openPopup(){
        $("#ModalRedirect").modal("show");
      },
      closedModal(){
        $("#ModalRedirect").modal("hide");
      },
      IrMotero(){
        localStorage.setItem('flagUpdateData', 2);
        $("#ModalRedirect").modal("hide");
        this.$router.push({ name: "login" });
      },
      IrLubricador(){
        localStorage.setItem('flagUpdateData', 2);
        $("#ModalRedirect").modal("hide");
        this.$router.push({ name: "loginLubricator" });
      },
    },
  }
</script>

<style scoped>
.content_btn{
  position: fixed;
  bottom: 100px;
  right: 10px;
  z-index: 9999;
  width: 170px;
}
.modal_content_popup{
  padding: 10px 20px 20px 20px;
  max-width: 95%;
  margin: auto;
}
.content_close{
  margin: -23px -29px auto auto;
  cursor: pointer;
}
</style>
